"use strict";

import axios from "axios";

const TOKEN_KEY = 'healthToken';
const VALID_TO_KEY = 'healthTokenValidTo';

function healthBaseUrl() {
    const explicit = window.__env?.health?.url;

    if (explicit) {
        return explicit;
    }

    const apiUrl = window.__env?.api?.url || process.env.baseURL || process.env.apiUrl || '';

    if (apiUrl) {
        return apiUrl.replace(/\/?api\/v1\/?$/, '/api');
    }

    return '/api';
}

function basicHeader(email, password) {
    const raw = `${email}:${password}`;

    return 'Basic ' + btoa(unescape(encodeURIComponent(raw)));
}

const healthClient = axios.create({
    baseURL: healthBaseUrl(),
    withCredentials: false,
});

healthClient.interceptors.request.use(function (config) {
    config.headers.Accept = 'application/json';

    const token = localStorage.getItem(TOKEN_KEY);

    if (token && !config.headers.Authorization) {
        config.headers.Authorization = 'Bearer ' + token;
    }

    return config;
});

healthClient.interceptors.response.use(function (response) {
    const envelope = response.data;

    if (!envelope || typeof envelope !== 'object' || !('IsSuccessful' in envelope)) {
        return response;
    }

    if (envelope.IsSuccessful) {
        response.envelope = envelope;
        response.data = envelope.Data;

        return response;
    }

    const error = new Error(`Health API error: ${envelope.Result} / ${envelope.Type}`);
    error.envelope = envelope;

    return Promise.reject(error);
});

export function acquireToken(credentials) {
    return healthClient.post('token', null, {
        headers: {Authorization: basicHeader(credentials.email, credentials.password)},
    }).then((response) => {
        const token = response.data?.Token;
        const validTo = response.data?.ValidTo;

        if (token) {
            localStorage.setItem(TOKEN_KEY, token);
            localStorage.setItem(VALID_TO_KEY, validTo || '');
        }

        return {token, validTo};
    });
}

export function extendToken() {
    return healthClient.post('token/extend').then((response) => {
        const token = response.data?.Token;
        const validTo = response.data?.ValidTo;

        if (token) {
            localStorage.setItem(TOKEN_KEY, token);
            localStorage.setItem(VALID_TO_KEY, validTo || '');
        }

        return {token, validTo};
    });
}

export function clearToken() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(VALID_TO_KEY);
}

export function hasValidToken() {
    const token = localStorage.getItem(TOKEN_KEY);
    const validTo = localStorage.getItem(VALID_TO_KEY);

    if (!token) {
        return false;
    }

    return !validTo || new Date(validTo).getTime() > Date.now();
}

export default healthClient;
